var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgStratResearch(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 130,
    height: 89,
    viewBox: "0 0 130 89",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_8)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M128.37 41.04C120.86 31.01 95.1901 0 64.6601 0C34.1401 0 8.46006 31.01 0.950059 41.04C-0.319941 42.74 -0.319941 45.51 0.950059 47.21C8.45006 57.24 34.1401 88.25 64.6601 88.25C95.1901 88.25 120.86 57.24 128.37 47.21C129.64 45.51 129.64 42.74 128.37 41.04ZM64.6601 83.65C42.8301 83.65 25.1301 65.95 25.1301 44.12C25.1301 22.29 42.8301 4.59 64.6601 4.59C86.4901 4.59 104.19 22.29 104.19 44.12C104.19 65.95 86.4901 83.65 64.6601 83.65Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.1299 44.12C89.1299 57.63 78.1699 68.59 64.6599 68.59C51.1499 68.59 40.1899 57.63 40.1899 44.12C40.1899 30.61 51.1499 19.65 64.6599 19.65C78.1699 19.66 89.1299 30.61 89.1299 44.12Z",
    fill: "#FAFAFA"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_8"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 129.33,
    height: 88.25,
    fill: "black"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStratResearch);
export default __webpack_public_path__ + "static/media/StratResearch.593cb6e8b6c04b06119026d026dfff21.svg";
export { ForwardRef as ReactComponent };